<div class="d-flex flex-column" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'" [hidden]="slideError">
    <div class="d-flex" style="flex:1" *ngIf="verticalLayout">
        <div class="wallboardCustomKpiBarView" [ngStyle]="{ 'border-color' : objectiveColor }"></div>
        <div style="flex:1">
            <div class="h-75">
                <div class="wallboardSetupCustomKpiTitle txtOverflow wallboardCustomKpiCenter"
                     [ngStyle]="{ 'visibility' : kpiState?.KpiTitle == '' ? 'hidden' : 'visible', 'font-size': titleFontSize, 'height': titleHeight }">
                    {{kpiState?.KpiTitle}}
                </div>

                <div class="wallboardsetupcustomkpi wallboardCustomKpiCenter" [ngStyle]="{ 'font-size': valueFontSize, 'height': valueHeight }">{{kpiData?.Metric_Data.MetricDisplayValue}}</div>
            </div>
            <div>
                <div class="wallboardsetupcustomkpimetric txtOverflow wallboardCustomKpiCenter m-auto" [ngStyle]="{ 'font-size': vMetricFontSize, 'height': metricHeight }">{{kpiMetricName}}</div>
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center flex-grow-1" *ngIf="!verticalLayout">
        <div class="wallboardCustomKpiBarView h-100" [ngStyle]="{ 'border-color' : objectiveColor }"></div>

        <div class="h-75 w-100 flex-grow-2">
            <div class="text-truncate text-center" 
                 [ngStyle]="{ 'visibility': kpiState?.KpiTitle ? 'visible' : 'hidden', 'font-size': titleFontSize, 'height': titleHeight }">
                {{ kpiState?.KpiTitle }}
            </div>
    
            <div class="text-center" 
                 [ngStyle]="{ 'font-size': valueFontSize, 'height': valueHeight }">
                {{ kpiData?.Metric_Data.MetricDisplayValue }}
            </div>
    
            <div class="text-truncate text-center mx-auto" 
                 [ngStyle]="{ 'font-size': hMetricFontSize, 'height': metricHeight, 'max-width': '100%' }">
                {{ kpiMetricName }}
            </div>
        </div>
    </div>
    
</div>

<div class="wvCustomItem wvSlideError d-flex" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
